// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"433":"434657a0","591":"d86b6d07"}[chunkId] + ".chunk.css";
};